import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Navbar() {
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        🏠 PLAN READER
      </Link>
      <div className="navbar-right">
        <button className="btn-primary" onClick={() => navigate('/upload')}>
          + New Project
        </button>
        <div className="avatar">JD</div>
      </div>
    </nav>
  );
}

export default Navbar;